import gql from 'graphql-tag'

export const PRODUCT_DESCRIPTION = gql`
  query Product($sku: SKU!, $descriptionKeys: [String!] = []) {
    product(sku: $sku, strict: false) {
      sku
      title
      content(keys: $descriptionKeys) {
        key
        value {
          __typename
          ... on ProductContentStringValue {
            stringValue: value
          }
          ... on ProductContentStringListValue {
            stringListValue: value
          }
          ... on ProductContentIntValue {
            intValue: value
          }
          ... on ProductContentIntListValue {
            intListValue: value
          }
          ... on ProductContentRichContentValue {
            richContentValue: value {
              content {
                type
                content
              }
            }
          }
          ... on ProductContentRichContentListValue {
            richContentListValue: value {
              content {
                type
                content
              }
            }
          }
        }
      }
    }
  }
`
